import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { _NkInput as NkInput } from '@nordkap/nordkap-ui';
import { useStyles } from '../styles';
import { combineClasses } from '../../../utils/styling';
import {
  row,
  accountNumberSize,
  accountNumberInputSize,
  accountNumberIsValid,
  TemplateContainer,
  createAccountObjectChangeObject,
} from '../utils';

const AccountNumber = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [accountNumber, setAccountNumber] = useState('');

  useEffect(() => {
    setAccountNumber(props.rule[props.transactionType].accountNumber || '');
  }, [props.transactionType, props.rule]);

  const templateContainer = TemplateContainer.useContainer();

  const handleValueChange = useCallback(
    event => {
      setAccountNumber(event.target.value);
      templateContainer.changeAccountNumber(
        createAccountObjectChangeObject(
          props.rule,
          props.transactionType,
          null,
          null,
          event.target.value
        )
      );
    },
    [props.transactionType, props.rule, templateContainer]
  );

  return (
    <Grid
      container
      item
      alignItems="flex-end"
      justifyContent="space-evenly"
      wrap="nowrap"
      direction="column"
      {...accountNumberSize}
      classes={{ root: classes.AccountNumberField }}
    >
      <Grid container item xs={row}>
        <label
          className={combineClasses([
            classes.Bold,
            classes.UpperCase,
            classes.AccountLabel,
          ])}
        >
          {t('templateRuleAccount.title')}
        </label>
      </Grid>
      <Grid container item xs={row} className={classes.Field}>
        <Grid item {...accountNumberInputSize}>
          <NkInput
            name={`account-number-${props.rule.eventType}-${props.transactionType}-${props.rule.index}`}
            variant="outlined"
            value={accountNumber}
            onChange={handleValueChange}
            placeholder={t('templateRuleAccount.accountNumber')}
            errorText={t('templateRuleAccount.accountNumberValidation')}
            isValid={accountNumberIsValid(accountNumber)}
            required
            inputClasses={{ root: classes.FieldBackground }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

AccountNumber.propTypes = {
  rule: PropTypes.object,
  transactionType: PropTypes.string,
};

export default AccountNumber;
